import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Agenda pro založení nové série pod existujícím produktem.
 * Otevírá se z plus akce na řádku produktu ve stromu; `productId` určuje nadřazený produkt.
 */
export const serieFormAgenda = defineAgenda({
  id: 'app.planner.serie-form',
  path: 'app/planner/serie',
  open: {
    productId: param.uuid(),
  },
  title: 'Nová série',
  icon: 'layers',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
